// Cede a thread principal: o navegador pinta o feedback da interação antes do
// trabalho pesado, que deixa de contar no INP.
export function afterNextPaint(task: () => void): void {
  requestAnimationFrame(() => {
    setTimeout(task, 0)
  })
}
